import {useMutation} from "react-query";
import Alert from "react-s-alert";
import {get} from "lodash";

import {FacilityService} from "../../../services/FacilityService";
import {FacilityStatusEnum} from "../../../utils/types/facility";

type Params = {
  facilityId: string;
  status: FacilityStatusEnum.ACTIVE | FacilityStatusEnum.INACTIVE;
  includeInReporting?: boolean;
  onSuccess: () => Promise<void> | void;
};

export const useUpdateFacilityStatusMutation = () =>
  useMutation(
    async ({facilityId, status, includeInReporting}: Params) => {
      const response = await FacilityService.updateStatus(
        facilityId,
        status,
        includeInReporting,
      );
      if (!response.ok) {
        throw response;
      }
      return response;
    },
    {
      onError: response => {
        Alert.error(
          get(
            response,
            "data.detail",
            get(
              response,
              "data.message",
              "Failed to update the facility status.",
            ),
          ),
        );
      },
      // Returning the promise keeps the mutation loading until the caller's onSuccess is done
      onSuccess: (_, {onSuccess}) => onSuccess(),
    },
  );
